import React from "react";
import './title.css'
import { TbMathSymbols } from "react-icons/tb";
function Title() {
  return (
    <div>
        <div className="content_box">
          <TbMathSymbols id = "icn" />
          <h1>Calculator App using React</h1>
        </div>
    </div>
  );
}

export default Title;
